import { Stack, Typography } from '@mui/material';
import { ReactElement } from 'react';

import { Organization } from '@app/types/organization';

interface OrganizationDescriptionProps {
  organization: Organization;
}

export function OrganizationDescription({
  organization,
}: OrganizationDescriptionProps): ReactElement {
  const rows = [
    {
      label: '会社名',
      value: organization.customFields?.companyName,
    },
    {
      label: '所在地',
      value: organization.customFields?.address,
    },
    {
      label: '設立',
      value: organization.customFields?.establishment,
    },
    {
      label: '問い合わせ',
      sub: organization.customFields?.phoneNumberSub,
      value: organization.phoneNumber,
    },
    {
      label: '定休日',
      sub: organization.customFields?.closingDaySub,
      value: organization.customFields?.closingDay,
    },
    {
      label: '資本金',
      value: organization.customFields?.capital,
    },
    {
      label: '従業員数',
      value: organization.customFields?.size
        ? `${organization.customFields.size}`
        : '',
    },
    {
      label: '施工エリア',
      value: organization.customFields?.constructionArea,
    },
    {
      label: '施工実績',
      value: organization.customFields?.constructionResult,
    },
    {
      label: '対応可能工法',
      value: organization.customFields?.compatibleConstructionMethod,
    },
    {
      label: 'アフター・補償',
      value: organization.customFields?.compensate,
    },
    {
      label: 'ホームページ',
      value: organization.url,
    },
  ];

  return (
    <>
      <Typography
        maxWidth={1000}
        color="white"
        align="center"
        paddingY={1}
        width="100%"
        mx="auto"
        mt={6}
        borderRadius={50}
        bgcolor="#3287E1"
        sx={{
          fontSize: 'clamp(1.375rem, 1.3068rem + 0.28vw, 1.5rem)',
          fontWeight: 700,
        }}
      >
        会社情報
      </Typography>
      <Stack spacing={2.5} maxWidth={1000} mx="auto" mt={6} pb={7} width="100%">
        {rows.map(({ label, value }, index) => (
          <Stack
            borderBottom={1}
            borderColor="#E0E0E0"
            key={index}
            direction={{ sm: 'row', xs: 'column' }}
            spacing={1}
            pb={2.5}
          >
            <Typography
              sx={{
                color: '#718CA0',
                fontWeight: 700,
                minWidth: 200,
                whiteSpace: 'nowrap',
              }}
            >
              {label}
            </Typography>
            <Typography
              sx={{
                whiteSpace: 'pre-wrap',
              }}
            >
              {value}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </>
  );
}
